import { NextButtonField } from '../checkInReserve/nextButtonField';
import { CheckInAnnounceCard } from './checkInAnnounceCard';
import './checkInCarConditionStyle.css';
import { EntryCarConditionField } from './entryCarCondition';
import {
  CarConditionEntryItemType,
  DamageMapItemType,
} from '@/types/bodyAndPaint';

interface CheckInCarConditionProps {
  state: CarConditionEntryItemType;
  setState: {
    isDrivenSelect: (select: number) => void;
    damageMapCheck: (key: keyof DamageMapItemType) => void;
    damageDegreeSelect: (select: number) => void;
    otherPartSelect: (select: number) => void;
    noticeDateText: (text: string) => void;
    descriptionText: (text: string) => void;
  };
  list: {
    isDrivenSelect: string[];
    damageDegreeSelect: string[];
    otherPartSelect: string[];
  };
  error: {
    noticeDateText: string;
    descriptionText: string;
  };
  pickerInfo: {
    pickerSelect: string;
    pickerInputID: string;
    pickerContainerID: string;
  };
  disabled: boolean;
  onNext: () => void;
}
export const CheckInCarCondition = ({
  state,
  setState,
  list,
  error,
  pickerInfo,
  disabled,
  onNext,
}: CheckInCarConditionProps) => {
  return (
    <div className={'check-in-car-condition-field'}>
      <div className={'car-condition-entry-field'}>
        <CheckInAnnounceCard />
        <EntryCarConditionField
          state={state}
          setState={setState}
          list={list}
          error={error}
          pickerInfo={pickerInfo}
        />
      </div>
      <NextButtonField disable={disabled} onClick={onNext} />
    </div>
  );
};
